import { Heading, Panel, PanelBody } from '@gitbook/spine-react';

import type { SitesCustomizationPanelProps } from '../types';
import { SidebarBackgroundStyleSetting, SidebarListStyleSetting } from './Sidebar';

/**
 * Handle the sidebar styling settings.
 */
export function SidebarPanel(props: SitesCustomizationPanelProps) {
    return (
        <Panel>
            <Heading>Sidebar styles</Heading>
            <PanelBody>
                <SidebarBackgroundStyleSetting {...props} />
                <SidebarListStyleSetting {...props} />
            </PanelBody>
        </Panel>
    );
}
